module.exports = __webpack_public_path__ + "img/P35-en.66afacca.png";